export const baseOwnerUrl = () => {
  return "/api/v1/owner"
}

export const baseManagerUrl = () => {
  return "/api/v1/manager"
}

export const URLS = {
  CLINIC_COUPONS: () => `${baseOwnerUrl()}/clinic_coupons`,
  CLINIC_COUPON: (id) => `${baseOwnerUrl()}/clinic_coupons/${id}`,

  MENU_COUPONS: () => `${baseOwnerUrl()}/menu_coupons`,
  MENU_COUPON: (id) => `${baseOwnerUrl()}/menu_coupons/${id}`,

  UPDATE_CLINIC_COUPON_THERAPIST: () => `${baseOwnerUrl()}/clinic_coupons/update_therapist_position`,

  CLINIC_CUSTOMERS: () => `${baseOwnerUrl()}/customers`,
  CLINIC_CUSTOMER_NOTES: () => `${baseOwnerUrl()}/clinic_customer_notes/search`,
  CLINIC_CUSTOMER: (id) => `${baseOwnerUrl()}/customers/${id}`,
  SQUARE_API_PAYMENTS: (id) => `${baseOwnerUrl()}/sale_managers`,
  THERAPISTS: () => `${baseOwnerUrl()}/therapists`,
  DATA_PARENT_REPORT_CHARTS: () => `${baseOwnerUrl()}/parent_reports/`,
  DATA_ANALYTICS: () => `${baseOwnerUrl()}/sale_managers/analytics`,

  MEMBERSHIP_CHARGES: () => `${baseOwnerUrl()}/points/membership_charges`,
  MEMBERSHIP_CHARGE: (id) => `${baseOwnerUrl()}/points/membership_charges/${id}`,

  MEMBERSHIP_SUBSCRIPTIONS: () => `${baseOwnerUrl()}/points/membership_subscription_roots`,
  MEMBERSHIP_SUBSCRIPTION: (id) => `${baseOwnerUrl()}/points/membership_subscription_roots/${id}`,

  CHARGE_PACKAGES: () => `${baseOwnerUrl()}/points/point_packages/get_list_packages?type=MembershipCharge`,
  SUBSCRIPTION_PACKAGES: () => `${baseOwnerUrl()}/points/point_packages/get_list_packages?type=MembershipSubscriptionRoot`,

  USER_PROFILE: () => `${baseOwnerUrl()}/profile`,

  COUPON_CLINICS: () => `${baseOwnerUrl()}/clinics/coupon_clinics`,
  MEMBERSHIP_CHARGE_CLINICS: () => `${baseOwnerUrl()}/clinics/membership_charge_clinics`,
  MEMBERSHIP_SUBSCRIPT_CLINICS: () => `${baseOwnerUrl()}/clinics/membership_subscript_clinics`,
  POINT_CLINICS: () => `${baseOwnerUrl()}/clinics/point_clinics`,
  CURRENT_CLINIC_CUSTOMER_NOTES: () => `${baseManagerUrl()}/clinic_customer_notes`,
  OWNER_CLINIC_MENU_COUPON: () => `${baseOwnerUrl()}/menu_coupons`,
  CLINIC_MENU_COUPON: () => `${baseManagerUrl()}/menu_coupons`,

  MANAGER_MENU_COUPONS: () => `${baseManagerUrl()}/menu_coupons`,
  MANAGER_MENU_COUPON: (id) => `${baseManagerUrl()}/menu_coupons/${id}`,
  CLINIC_NAME_MENU_COUPONS: () => `${baseManagerUrl()}/menu_coupons/list_clinic_name`,

  CURRENT_CLINIC: () => `${baseOwnerUrl()}/clinics/current`,
};
